import { render, staticRenderFns } from "./SettlementVerifyIbanModal.vue?vue&type=template&id=00bb2029&scoped=true"
import script from "./SettlementVerifyIbanModal.vue?vue&type=script&lang=js"
export * from "./SettlementVerifyIbanModal.vue?vue&type=script&lang=js"
import style0 from "./SettlementVerifyIbanModal.vue?vue&type=style&index=0&id=00bb2029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb2029",
  null
  
)

export default component.exports